import React, { useEffect } from "react";
import HomeMobileNavbar from "../components/HomeMobileNavbar";
import Navbar from "../components/Navbar";

const faqsData = [
  {
    id: "01",
    title: "Welcome to Nufab!",
    items: [
      {
        q: "We appreciate your trust and are committed to safeguarding your privacy and personal data. Our Privacy Policy explains how we handle your information when you interact with us. Please take a moment to read our policy, as by using Nufab, you are agreeing to our terms.",
      },
      {
        q: "Email: nufab.info@gmail.com",
      },
      {
        q: "Phone: +91 9244501941",
      },
      {
        q: "Contact us at Studio Address: 201, 76-77 P-Prime, Shakti Nagar, 452018, Indore",
      },
      {
        q: "Registered Address: Exora 501 Shalimar Township, AB Road, Indore.",
      },
      {
        q: "Support Hours: Monday to Saturday, 11:00 AM – 7:00 PM IST",
      },
    ],
  },
  {
    id: "02",
    title: "Data Collection",
    items: [
      {
        q: "We gather necessary details like your name, address, email, and phone number to process transactions. We also collect device information, like IP addresses, to enhance your browsing experience. With your consent, we may also collect info to send marketing emails about product updates and offers.",
      },
      {
        q: "By sharing your details, you agree to let us use them for specific purposes like order processing and customer support. You can opt out of promotional messages anytime.",
      },
      {
        q: "If you want to delete your account, email us at our support email people@nufab.studio and we will delete all your information for future use from our system.",
      },
      {
        q: "Our payments are processed securely through trusted gateway (RazorPay), and we don’t store your financial info.",
      },
      {
        q: "We will retain your personal data only for as long as is necessary for the purposes set out in this Privacy Policy. Specifically, we maintain your information for a period of five (5) years from the date of your last interaction with us, or as required to comply with our legal obligations, resolve disputes, and enforce our legal agreements.",
      },
    ],
  },
  {
    id: "03",
    title: "Data Sharing",
    items: [
      {
        q: "We don't sell or trade your data. We may share it: - If required by law or to protect our rights - During business transfers or mergers - With trusted service providers for payment, order fulfillment, and marketing (they’re bound by confidentiality agreements)",
      },
      {
        q: "Our delivery and payment partners only access your info as needed to provide their services and may have their own privacy policies.",
      },
      {
        q: "We use industry-standard security measures to prevent unauthorized access or misuse. If you suspect a breach, contact us ASAP.",
      },
    ],
  },
  {
    id: "04",
    title: "Governing Law",
    items: [
      {
        q: "These terms are governed by Indian law, and any disputes will be resolved through arbitration in accordance with Indian Arbitration and Conciliation Act, 1996.",
      },
    ],
  },
];

const PrivacyPage = () => {
  const [windowWidth, setWindowWidth] = React.useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      {windowWidth < 1168 ? <HomeMobileNavbar /> : <Navbar />}
    <div className="w-full max-w-full mx-auto px-4 md:px-6 py-10 md:py-20 font-[bdogrotesk] text-black">
      <p className="text-black text-lg font-medium mb-6 md:mb-0">Privacy Policy</p>
      {faqsData.map((section, sectionIdx) => (
        <div
          key={section.id}
          // RESPONSIVE: Stack vertically on mobile (flex-col), horizontal on desktop (lg:flex-row)
          className="flex flex-col lg:flex-row gap-6 lg:gap-10 border-b border-black pt-10 pb-4 md:pb-10 lg:pb-0"
        >
          {/* Left column (ID) */}
          <div className="text-base font-medium text-black tracking-wide w-full lg:w-20 flex-shrink-0">
            {section.id}
          </div>

          {/* Right column Wrapper */}
          {/* RESPONSIVE: Stack on mobile and use balanced desktop columns */}
          <div className="flex-1 flex flex-col gap-8 lg:grid lg:grid-cols-[minmax(260px,1fr)_minmax(560px,1.2fr)] lg:items-start lg:gap-10">
            
            {/* Title */}
            {/* RESPONSIVE: Scale font size and center title block on desktop */}
            <h2 className="w-full max-w-[420px] text-3xl md:text-5xl lg:text-6xl font-medium break-words lg:justify-self-center">
              {section.title}
            </h2>

            {/* Items List */}
            <div className="space-y-4 w-full">
              {section.items.map((item, itemIdx) => {
                const key = `${sectionIdx}-${itemIdx}`;
                const isLast = itemIdx === section.items.length - 1;

                return (
                  <div
                    key={key}
                    className={`${!isLast ? "border-b border-black" : ""} pb-4`}
                  >
                    <button
                      className="w-full flex justify-between items-start text-left cursor-default"
                    >
                      <span className="text-sm md:text-base text-black font-medium pr-0 md:pr-6 leading-relaxed">
                        {item.q}
                      </span>
                    </button>

                    {/* Hidden answer div to maintain structure */}
                    <div className={`overflow-hidden transition-all duration-300 ease-in-out hidden`}>
                      <div className="overflow-hidden">
                        <p className="text-base leading-relaxed pr-10">
                          {/* {item.a} */}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      ))}
    </div>
    </div>
  );
};

export default PrivacyPage;